// import api from './api';
import { apiUtils } from '../utils/api';
export const getRelativesList = async () => {
  return await apiUtils.get('relatives/');
};

export const createRelative = async (form) => {
  const payload = {
    relative_name: form.relative_name,
    tel_no: form.tel_no,
    email: form.email,
    relation: form.relation,
    client: form.client
  };
  return await apiUtils.post('relatives/', payload);
}; 

export const updateRelative = async (id, form) => {
  const payload = {
    relative_name: form.relative_name,
    tel_no: form.tel_no,
    email: form.email,
    relation: form.relation,
    client: form.client,
  };
  return await apiUtils.put(`relatives/${id}/`, payload);
};

export const deleteRelative = async (id) => {
  return await apiUtils.delete(`relatives/${id}/`);
};
